<div class="row">

    <nb-card class="custom">
        <div class="mt-3    ">
            <button type="submit" style="float: right" class="btn btn-primary btn-sm" (click)="onBack()">
                Close
            </button>
        </div>
        <div class="mt-2" style="padding: 10px;">
            <h4>Store url is:</h4>
            <div><span>{{this.storeurl}} </span>
            </div>
        </div>
    </nb-card>

</div>